import { render, staticRenderFns } from "./mindTest.vue?vue&type=template&id=c41d4f40&scoped=true&"
import script from "./mindTest.vue?vue&type=script&lang=js&"
export * from "./mindTest.vue?vue&type=script&lang=js&"
import style0 from "./mindTest.vue?vue&type=style&index=0&id=c41d4f40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41d4f40",
  null
  
)

export default component.exports